/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable view-models/no-unused-meta */
/* eslint-disable react/prop-types */
// TODO: remove view-models/no-unused-meta and eslint-disable react/prop-types rule when this issue https://github.com/asbjornh/view-models/issues/18 is resolved
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import LinkBase from 'components/models/link-base';
import Icon from 'components/icon';
import cn from 'classnames';

// eslint-disable-next-line view-models/no-errors
export const themes = {
  light: 'light',
  lightTotal: 'light-total',
  dark: 'dark',
  darkTotal: 'dark-total',
};

// eslint-disable-next-line view-models/no-errors
export const sizes = {
  small: 'small',
  normal: 'normal',
  large: 'large',
};

// eslint-disable-next-line view-models/no-errors
export const types = {
  regular: 'regular',
  external: 'external',
  restricted: 'restricted',
  download: 'download',
};

// eslint-disable-next-line view-models/no-errors
export const actionTypes = {
  expand: 'expand',
  toggle: 'toggle',
  back: 'back',
};

// eslint-disable-next-line view-models/no-errors
export const behaviors = {
  text: 'text',
};

const mapLinkTypeToIconName = linkType => {
  switch (linkType) {
    case types.external:
      return 'external';
    case types.restricted:
      return 'lock';
    case types.download:
      return 'download-outline';
    case types.regular:
    default:
      return 'arrow-right';
  }
};

const mapActionTypeToIconName = actionType => {
  switch (actionType) {
    case actionTypes.expand:
      return 'expand';
    case actionTypes.toggle:
      return 'toggle';
    case actionTypes.back:
      return 'arrow-left';
    default:
      return null;
  }
};

const Link = ({
  className,
  openInNewTab = false,
  url,
  text,
  tabindex,
  theme = themes.dark,
  size = sizes.normal,
  type,
  action,
  behavior,
  onFocus = () => {},
  onBlur = () => {},
}) => {
  const linkIcon = useMemo(() => mapLinkTypeToIconName(type), [type]);
  const actionIcon = useMemo(() => mapActionTypeToIconName(action), [action]);
  const RootComponent = url ? 'a' : 'span';

  return (
    <RootComponent
      href={url}
      className={cn('link', {
        [`link_theme-${theme}`]: theme,
        [`link_size-${size}`]: size,
        [className]: className,
      })}
      target={openInNewTab ? '_blank' : null}
      rel={openInNewTab ? 'nofollow noopener noreferrer' : null}
      tabIndex={tabindex}
      onFocus={onFocus}
      onBlur={onBlur}
    >
      {actionIcon && behavior !== behaviors.text && (
        <Icon name={actionIcon} className="link__icon link__icon_left" />
      )}
      <span className="link__text">{text}</span>
      {linkIcon && !action && behavior !== behaviors.text && (
        <Icon name={linkIcon} className="link__icon link__icon_right" />
      )}
    </RootComponent>
  );
};

Link.viewModelMeta = {
  className: 'ignore',
  tabindex: 'ignore',
  theme: 'ignore',
  size: 'ignore',
  action: 'ignore',
  behavior: 'ignore',
  onFocus: 'ignore',
  onBlur: 'ignore',
};

Link.propTypes = Object.assign({}, LinkBase.propTypes, {
  className: PropTypes.string,
  tabindex: PropTypes.number,
  theme: PropTypes.oneOf(Object.values(themes)),
  size: PropTypes.oneOf(Object.values(sizes)),
  type: PropTypes.oneOf(Object.values(types)),
  action: PropTypes.oneOf(Object.values(actionTypes)),
  behavior: PropTypes.oneOf(Object.values(behaviors)),
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
});

// eslint-disable-next-line view-models/no-errors
export default Link;
